<template>
  <div>
    <ul class="nav">
      <li @click="current = 0" :class="{ active: current == 0 }">
        <p class="nav_tab">未使用</p>
        <p class="nav_active" v-if="current == 0"></p>
      </li>
      <li @click="current = 1" :class="{ active: current == 1 }">
        <p class="nav_tab">已使用</p>
        <p class="nav_active" v-if="current == 1"></p>
      </li>
      <li @click="current = 2" :class="{ active: current == 2 }">
        <p class="nav_tab">已过期</p>
        <p class="nav_active" v-if="current == 2"></p>
      </li>
    </ul>
    <div class="content">
      <div v-show="current == 0" class="main_content">
        <ul class="main">
          <li>
            <div class="main_left">
              <img src alt />
            </div>
            <div class="main_right">
              <p class="coupon_num"><span>100000</span>元</p>
              <p class="coupon_limit">全场通用</p>
              <p class="coupon_date">
                有效期：
                <span>2019.1.1 -2019.3.31</span>
              </p>
            </div>
          </li>
          <li>
            <div class="main_left">
              <img src alt />
            </div>
            <div class="main_right">
              <p class="coupon_num"><span>100000</span>元</p>
              <p class="coupon_limit">全场通用</p>
              <p class="coupon_date">
                有效期：
                <span>2019.1.1 -2019.3.31</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div v-show="current == 1" class="main_content">
        <ul class="main">
          <li class="old_coupon">
            <div class="main_left">
              <img src alt />
            </div>
            <div class="main_right">
              <p class="coupon_num"><span>100000</span>元</p>
              <p class="coupon_limit">全场通用</p>
              <p class="coupon_date">
                有效期：
                <span>2019.1.1 -2019.3.31</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div v-show="current == 2" class="main_content">
        <ul class="main">
          <li class="old_coupon">
            <div class="main_left">
              <img src alt />
            </div>
            <div class="main_right">
              <p class="coupon_num"><span>100000</span>元</p>
              <p class="coupon_limit">全场通用</p>
              <p class="coupon_date">
                有效期：
                <span>2019.1.1 -2019.3.31</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "coupon",
  data() {
    return {
      current: 0
    };
  }
};
</script>
<style scoped>
.nav {
  height: 0.7rem;
  padding: 0.35rem 0.7rem 0.25rem 0.8rem;
  background-color: #ffffff;
}
.nav li {
  float: left;
  width: 1.12rem;
  margin-right: 1.1rem;
  font-size: 0.26rem;
  color: #666666;
}
.nav li:last-child {
  margin-right: 0;
}
.nav_tab {
  width: 1.12rem;
  height: 0.6rem;
  line-height: 0.6rem;
}
.nav_active {
  width: 0.66rem;
  border-bottom: 0.1rem solid #04ea6c;
  margin: 0 auto;
}
.content {
  background-color: #f6f6f6;
  padding-top: 0.28rem;
}
.main_content {
  background-color: #fff;
  padding: 0.4rem 0.2rem 0;
}
.main li {
  width: 7.09rem;
  height: 1.14rem;
  margin-bottom: 0.16rem;
  background-color: #fff5f3;
  border: 1px solid #fff5f3;
  border-radius: 20px 20px;
  padding: 0.26rem 0;
}
.main_left {
  float: left;
  width: 0.8rem;
  height: 1.14rem;
  padding: 0 0.2rem 0 0.32rem;
}
.main_left img {
  width: 100%;
  height: 100%;
  border: 1px solid #ddd;
}
.main_right {
  float: left;
}
.coupon_num {
  height: 0.58rem;
  line-height: 0.58rem;
  font-size: 0.22rem;
  color: #ff3301;
  text-align: left;
  font-weight: bold;
}
.coupon_num span {
  font-size: 0.44rem;
}
.coupon_limit {
  height: 0.3rem;
  line-height: 0.3rem;
  font-size: 0.2rem;
  color: #646665;
  text-align: left;
}
.coupon_date {
  height: 0.28rem;
  line-height: 0.28rem;
  font-size: 0.2rem;
  color: #646665;
  text-align: left;
}
.main .old_coupon {
  background-color: #f8f8f8;
  border: 1px solid #f8f8f8;
}
.old_coupon .coupon_num {
  color: #6f6f6f;
}
</style>
